const { Optional } = require('lonad');
const Callcise = require('callcise');
const pipe = require('lodash.flow');
const evaluate = Callcise.internal.evaluate;
const namespacedVuexInvokers = (optionalNamespace = Optional.None()) => {
    function vuexQuery(queryName, ...parameters) {
        return function query(...additionalParameters) {
            const getter = this.$store.getters[makeMethodName(queryName)];
            return getter(...evaluate(this, parameters).concat(additionalParameters));
        };
    }
    function vuexState(propertyName) {
        return function retrieve() {
            return optionalNamespace
                .map(namespace => this.$store.state[namespace])
                .recover(() => this.$store.state)
                .property(propertyName)
                .get();
        };
    }
    function vuexGetter(getterName) {
        return function getter() {
            return this.$store.getters[makeMethodName(getterName)];
        };
    }
    function vuexMutation(mutationName, predefinedPayload) {
        return function mutation(callbackPayload) {
            let payload = predefinedPayload ? evaluate(this, [predefinedPayload])[0] : callbackPayload;
            return this.$store.commit(makeMethodName(mutationName), payload);
        };
    }
    function vuexAction(actionName, ...parameters) {
        return function action(...additionalParameters) {
            return this.$store.dispatch(makeMethodName(actionName), ...evaluate(this, parameters).concat(additionalParameters));
        };
    }
    return {
        query: vuexQuery,
        state: vuexState,
        getter: vuexGetter,
        action: vuexAction,
        mutation: vuexMutation
    };
    function makeMethodName(vuexMethodName) {
        return optionalNamespace
            .map(namespace => `${namespace}/${vuexMethodName}`)
            .getOrElse(vuexMethodName);
    }
};
const globalVuex = namespacedVuexInvokers();
module.exports = {
    namespaced: pipe(Optional.Some, namespacedVuexInvokers),
    vuexMutation: globalVuex.mutation,
    vuexState: globalVuex.state,
    vuexGetter: globalVuex.getter,
    vuexAction: globalVuex.action,
    vuexQuery: globalVuex.query
};
